import React from 'react';
import { StyledAvatar, StyledImage } from './index.styles.js';
import { Icon } from '../icon/index.js';
import {} from '@oneaudi/unified-web-common';
import { pickA11yProps } from '../../utils/pick-a11y-props.js';
import { pickDataProps } from '../../utils/pick-data-props.js';
export const Avatar = ({ size, onClick, label, variant, className, disabled, margin, image, ...rest }) => {
    const iconSize = size === 'lg' ? 'l' : size === 'md' ? 's' : 'xs';
    const a11yProps = pickA11yProps(rest);
    const dataProps = pickDataProps(rest);
    const getContent = () => {
        if (variant === 'logged-out') {
            return React.createElement(Icon, { size: iconSize, name: "user" });
        }
        if (image) {
            return React.createElement(StyledImage, { src: image.src, alt: image.alt, role: image.role });
        }
        return label;
    };
    return (React.createElement(StyledAvatar, { size: size, className: className, disabled: disabled, onClick: onClick, variant: variant, margin: margin, image: image, ...a11yProps, ...dataProps }, getContent()));
};
//# sourceMappingURL=index.js.map